<template>
  <div>
    <div id="headNav">
      <div class="leftArrow" @click="goBack"><van-icon name="arrow-left" /></div>
      <div class="title">{{$t('message.zc')}} <span style="margin: 0 3px">/</span> {{$t('message.loginIn')}}</div>
      <div class="leftArrow" ></div>
    </div>
    <div class="login_top">
      <div class="logo" >
        <img src="../../assets/images/3x/logo.png" alt="" style="width: 100%;border-radius: 100%">
      </div>
    </div>
    <van-tabs v-model="active" @click="onClick" :title-active-color="activeColor">
      <van-tab :title="$t('message.zc')+' / '+$t('message.loginIn')"></van-tab>
<!--      <van-tab :title="$t('message.loginIn')"></van-tab>-->
    </van-tabs>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
  export default {
    name: "auth",
    data(){
      return{
        active: 0,
        activeColor:''
      }
    },
    created() {
      this.activeColor = this.$color;
      switch (this.$route.name) {
        case 'register':
          this.active=0;
          break;
        default:
          this.active=1;
      }
    },
    methods:{
      onClick(name,title){
        if(name==0){
          this.active=0;
          this.$router.push('/auth/register')
        }else{
          this.active=1;
          this.$router.push("/auth/loginCode")
        }
      },
      goBack(){
        this.$router.push('/')
      }
    }
  }
</script>

<style scoped lang="scss">
  .login_top {
    background-image: url("../../assets/images/1x/login_top.png");

    [data-dpr="3"] & {
      background-image: url("../../assets/images/3x/login_top.png");
    }

    [data-dpr="2"] & {
      background-image: url("../../assets/images/2x/login_top.png");
    }
    background-size: cover;
    height: 6.68rem;
    width: 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    .logo {
      width: 2.04rem;
      height: 2.04rem;
      background: #fff;
      border-radius: 2.04rem;
      overflow: hidden;
      box-shadow: 0px 0px 10px #edf1f7;
    }
  }
  /deep/ .van-tabs__line{
    width: 50%!important;
    height: 2px!important;
    background-color:$color;
  }
  /deep/ .van-tab{
    border-bottom: 1px solid #bfc5d2!important;
  }
  #headNav{
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 5;
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
    /*background: rgba(0,0,0,0.1);*/
    color: #fff;
    .title{
      font-size: 18px;
      color: #fff;
      font-weight: 500;
    }
    .leftArrow{
      font-size: 18px;
      display: flex;
      align-items: center;
      width: 40px;
    }
  }
  /deep/ .van-tab{
    font-size: 0.5rem!important;
    line-height: 1.2rem!important;
  }
  /deep/ .van-tabs--line .van-tabs__wrap{
    height: 1.2rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/auth.vue